// A directive used to lazy load images (i.e. games list icons) as soon as their placeholders enter the viewport
// Using IntersectionObserver pattern
export default {
  inserted: el => {
    function loadImage() {
      const imageElement = Array.from(el.children).find(
        // @ts-ignore
        el => el.nodeName === "IMG"
      ) as HTMLElement;
      if (imageElement) {
        imageElement.addEventListener("load", () => {
          setTimeout(() => el.classList.add("loaded"), 100);
        });
        imageElement.addEventListener("error", () => console.log("error"));
        // @ts-ignore
        imageElement.src = imageElement.dataset.url;
      }
    }

    function handleIntersect(entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadImage();
          observer.unobserve(el);
        }
      });
    }

    function createObserver() {
      const options = {
        root: null,
        threshold: 0
      };
      const observer = new IntersectionObserver(handleIntersect, options);
      observer.observe(el);
    }
    //Fallback for IE browsers
    if (window["IntersectionObserver"]) {
      createObserver();
    } else {
      loadImage();
    }
  }
};
